import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import rocketPicture from './../../../../assets/resolution/rocketPicture.svg';
import clockPicture from './../../../../assets/resolution/clockPicture.svg';
import closedPicture from './../../../../assets/resolution/closedPicture.svg';
import { Text } from '../../../layout/theme/components';

const StatsWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 5%;
`;
const StatsBox = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  flex: 1 1;
  margin: 1em 0;
  min-width: 250px;
`;
const ImgWrapper = styled.span`
  width: 85px;
  height: 75px;
  text-align: right;
  margin-right: 2em;

  img {
    height: 100%;
  }
`;
const Label = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  text-align: left;
`;
const LabelValue = styled.span`
  font-size: 2.4em;
  color: ${({ theme }) => theme.textColors.secondary};
`;
const StyledText = styled(Text)`
  margin: 0;
`;

const ResolutionStatistics = props => {
  const { startDate, duration, closed } = props;

  return (
    <StatsWrapper>
      <StatsBox>
        <ImgWrapper>
          <img alt="" src={rocketPicture} />
        </ImgWrapper>
        <Label>
          <StyledText small>Data rozpoczęcia głosowania:</StyledText>
          <LabelValue>{startDate} r.</LabelValue>
        </Label>
      </StatsBox>
      <StatsBox>
        <ImgWrapper>
          <img alt="" src={closed ? closedPicture : clockPicture} />
        </ImgWrapper>
        <Label>
          <StyledText small>
            {closed ? 'Głosowanie zajęło:' : 'Głosowanie trwa od:'}
          </StyledText>
          <LabelValue>{duration}</LabelValue>
        </Label>
      </StatsBox>
    </StatsWrapper>
  );
};

ResolutionStatistics.propTypes = {
  startDate: PropTypes.string.isRequired,
  duration: PropTypes.string.isRequired,
  closed: PropTypes.bool
};

ResolutionStatistics.defaultProps = {
  closed: false
};

export default ResolutionStatistics;
